import { HookAPI } from 'antd/es/modal/useModal'

import ModalMessage from '@/components/Atoms/ModalMessage/ModalMessage'
import { GENERAL_ERRORS_MESSAGES } from '@/constants'

export default function zodErrorModalMessage(modal: HookAPI) {
  ModalMessage({
    title: GENERAL_ERRORS_MESSAGES.ZOD_ERROR,
    modal,
    messageType: 'error',
  })
}
